import 'styles/global/side.drawer.css';

const SideDrawer = props => {
    return (
        <>
            <div className='Screen' onClick={props.onCancel}></div>
            <div className={`SideDrawer ${props.className || ''} ${props.closing ? 'closing' : ''}`.trim()} onAnimationEnd={props.onAnimationEnd}>
                {props.children}
            </div>
        </>
    )
}

export default SideDrawer
